import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopInnerBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,

} from "../../components/common/UiPageElements"
import OrderContent from "./Views/OrderContent"
import OrderPointSection from "./Views/OrderPointSection"
import {
    UiOrderDetails,
    UiOrderDetailsColWr,
    UiOrderDetailsColName,
    UiOrderDetailsHr,
    UiOrderDetailsColStatus,
    UiOrderDetailsColValidUnit,
    UiOrderDetailsColLabel
} from "../../components/common/UiProductElements"
import { WhatsIncluded } from "./Views/WhatsIncluded"
import OrderTopDetails from "./Views/OrderTopDetails"
import Footer from "../../components/footer/Footer"
import London from "../../../../styles/img/london-img.jpg"
import CartPointSection from './Views/CartPointSection';
import { UiButtonPrimary, UiButtonSecondary } from "../../components/form/UiButton"


export default function MyCart(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="My Cart" />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Cart"
                    currentPageLink="/ui/cart" />
                <UiContentWr>
                    <div className='sb-cart-card-wr'>
                        <UiRowContainer fluid="fluid">
                            <h3>Ultimate London Weekend</h3>
                            <UiCol lg="5" className="mb-3">
                                <img src={London} className="img-fluid sb-product-info-img sb-product-info-lg" />
                            </UiCol>
                            <UiCol lg="4" className="mb-3">
                                <CartPointSection />
                            </UiCol>
                            <UiCol lg="3" className="sb-btn-remove">
                                <UiButtonPrimary btnName="Remove"/>
                                <p>Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.</p>
                            </UiCol>
                        </UiRowContainer>
                    </div>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>
        </>
    )
}
